import { Item } from '@radix-ui/react-dropdown-menu'

import { styled } from '~/styled'

export const DropdownMenuItem = styled(Item, {
  base: [
    'items-center',
    'text-grey-1000',
    'cursor-pointer',
    'flex',
    'font-body',
    'font-normal',
    'relative',
    'px-3',
    'py-2',
    'data-disabled:cursor-not-allowed',
    'data-disabled:opacity-30',
    'data-disabled:pointer-events-none',
    'aria-[current=page]:before:absolute',
    'aria-[current=page]:before:border-l-2',
    'aria-[current=page]:before:border-l-current',
    "aria-[current=page]:before:content-['']",
    'aria-[current=page]:before:h-6',
    'aria-[current=page]:before:left-0',
    'aria-[current=page]:before:outline-none',
    'aria-[current=page]:before:scale-100',
    'focus:before:absolute',
    'focus:before:border-l-2',
    'focus:before:border-l-current',
    "focus:before:content-['']",
    'focus:before:h-6',
    'focus:before:left-0',
    'focus:before:outline-none',
    'focus:before:scale-100',
    'focus:outline-none',
    'focus:text-primary-900',
    'hover:underline'
  ]
})
